<template>
    <lv-base-column
            ref="column" v-bind="columnBinding">
        <template slot-scope="{row,rowIndex,col,colIndex,editRow,fixedRow,}">
            <link-table-column-address-item
                    :row="row"
                    :edit-row="editRow"
                    :row-index="rowIndex"
                    :col="col"
                    :col-index="colIndex"
                    :fixed-row="fixedRow"
                    v-bind="columnItemBinding"
                    @click="lv_clickItem"

                    :map="map"
                    :types="types"
                    :title="title"
            />
        </template>
    </lv-base-column>
</template>

<script>
    import {ColumnMixin} from "../mixins";
    import LinkTableColumnAddressItem from "./link-table-column-address-item";
    import LvBaseColumn from "../../table/lv-base-column";

    export default {
        name: "link-table-column-address",
        components: {LvBaseColumn, LinkTableColumnAddressItem},
        mixins: [ColumnMixin],
        props: {
            width: {default: '80px'},

            map: {require: true},
            types: {type: Array,},                 // 设定link-address-modal的类型和返回数据形式
            title: {type: String, default: '请选择地址'},                                                    // 设定弹框标题
            formatter: {
                default() {
                    return (val, data) => {
                        const advances = this.$lv.$address.advances
                        let types = this.types || []
                        return [...types]
                            .sort((a, b) => advances[b] - advances[a])
                            .reduce((ret, key) => {
                                !!data.showRow[this.map[key]] && ret.push(data.showRow[this.map[key]])
                                return ret
                            }, [])
                            .join('/')
                    }
                },
            },
        },
    }
</script>
